export const removeExtraValues = (values: any) => {
  const newValues = {};

  for (const key of Object.keys(values)) {
    if (values[key]) newValues[key] = values[key];
  }

  return newValues;
};
